import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface ErrorMessageProps {
  title: string;
  message: string;
  actions?: {
    label: string;
    onClick: () => void;
  }[];
}

export function ErrorMessage({
  title,
  message,
  actions = [],
}: ErrorMessageProps) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="flex h-full flex-col items-center justify-center rounded-md bg-gray-50 p-6">
      <div className="flex max-w-lg flex-col items-center space-y-4 text-center">
        <AlertTriangle className="h-12 w-12 text-amber-500" />
        <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
        <p className="text-gray-600">{message}</p>

        {message.includes('Supabase') && (
          <div className="mt-4 w-full space-y-4">
            <Button
              variant="outline"
              className="w-full"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? 'Masquer les détails' : 'Afficher les détails'}
            </Button>

            {showDetails && (
              <div className="rounded-md bg-gray-100 p-4 text-left text-sm">
                <h3 className="mb-2 font-medium">Vérifiez ces points :</h3>
                <ul className="list-disc space-y-2 pl-5">
                  <li>
                    Le fichier <code>.env.local</code> existe dans le répertoire
                    racine
                  </li>
                  <li>Le service Supabase est opérationnel</li>
                  <li>Votre connexion internet fonctionne</li>
                </ul>
              </div>
            )}
          </div>
        )}

        {actions.length > 0 && (
          <div className="mt-4 flex space-x-4">
            {actions.map((action, index) => (
              <Button key={index} onClick={action.onClick}>
                {action.label}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
